/**
 * Country → currency mapping for cabinet accounts.
 *
 * Un cabinet travaille dans une seule devise : celle de son pays.
 * Les prix sont déjà convertis à la saisie (aucune conversion de taux ici).
 */

/** ISO 4217 currency used by each supported ISO 3166-1 alpha-2 country. */
export const COUNTRY_CURRENCY: Record<string, string> = {
  FR: 'EUR',
  BE: 'EUR',
  DE: 'EUR',
  LU: 'EUR',
  NL: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
  PT: 'EUR',
  AT: 'EUR',
  IE: 'EUR',
  RO: 'RON',
  CH: 'CHF',
  GB: 'GBP',
  PL: 'PLN',
  HU: 'HUF',
  CZ: 'CZK',
};

export const DEFAULT_COUNTRY = 'FR';
export const DEFAULT_CURRENCY = 'EUR';

/** Countries selectable in the cabinet settings form. */
export const SUPPORTED_COUNTRIES: string[] = Object.keys(COUNTRY_CURRENCY);

/**
 * Currency for a country code — falls back to EUR for unknown/missing codes.
 * Le jour où la Roumanie passe à l'euro, seule la table ci-dessus change.
 */
export function currencyForCountry(country?: string | null): string {
  if (!country) return DEFAULT_CURRENCY;
  return COUNTRY_CURRENCY[country.toUpperCase()] ?? DEFAULT_CURRENCY;
}

/** BCP 47 locale used for number formatting, derived from the UI language. */
export const LANGUAGE_LOCALE: Record<string, string> = {
  fr: 'fr-FR',
  ro: 'ro-RO',
  en: 'en-GB',
  de: 'de-DE',
};

export const DEFAULT_LOCALE = 'fr-FR';

export function localeForLanguage(language?: string | null): string {
  if (!language) return DEFAULT_LOCALE;
  return LANGUAGE_LOCALE[language.slice(0, 2).toLowerCase()] ?? DEFAULT_LOCALE;
}
